// Logic chèn markdown-lite `**đậm**` / `*nghiêng*` cho ô soạn nội dung bài
// Kênh Cộng Đồng (bản admin — giữ đồng bộ với
// frontend/src/pages/Community/community-markdown-insert.js).
//
// Renderer (frontend/src/pages/Community/community-linkified-text.js) chỉ nhận
// cặp dấu khi ký tự ngay sau `*` mở và ngay trước `*` đóng KHÔNG phải khoảng
// trắng. Chrome double-click chọn từ lại ăn kèm dấu cách cuối → bọc thô sẽ ra
// `**giá rẻ **` và KHÔNG in đậm. Vì vậy đẩy khoảng trắng đầu/cuối vùng chọn ra
// NGOÀI cặp dấu.

const PLACEHOLDER = "văn bản";
const TRIM_SPLIT_REGEX = /^(\s*)([\s\S]*?)(\s*)$/;

/**
 * Dựng nội dung mới khi bấm B/I.
 * @returns {{ value: string, selectionStart: number, selectionEnd: number }}
 *   - có bôi đen: con trỏ đặt ngay sau cặp dấu đóng
 *   - không bôi đen: bôi đen sẵn chữ mẫu để user gõ đè
 */
export function buildMarkdownInsert(value, start, end, marker) {
    const safeValue = value || "";
    const from = Math.max(0, Math.min(start ?? 0, safeValue.length));
    const to = Math.max(from, Math.min(end ?? from, safeValue.length));

    const [, lead = "", core = "", trail = ""] = safeValue.slice(from, to).match(TRIM_SPLIT_REGEX) || [];

    if (!core) {
        const at = from + lead.length;
        const nextValue = `${safeValue.slice(0, at)}${marker}${PLACEHOLDER}${marker}${safeValue.slice(at)}`;
        const coreStart = at + marker.length;
        return {
            value: nextValue,
            selectionStart: coreStart,
            selectionEnd: coreStart + PLACEHOLDER.length,
        };
    }

    const before = `${safeValue.slice(0, from)}${lead}`;
    const after = `${trail}${safeValue.slice(to)}`;
    const cursor = before.length + marker.length * 2 + core.length;
    return {
        value: `${before}${marker}${core}${marker}${after}`,
        selectionStart: cursor,
        selectionEnd: cursor,
    };
}

/** Phím tắt PC: Ctrl/Cmd + B → `**`, Ctrl/Cmd + I → `*`; null nếu không phải. */
export function getMarkdownShortcutMarker(event) {
    if (!event || !(event.ctrlKey || event.metaKey) || event.altKey) return null;
    const key = String(event.key || "").toLowerCase();
    if (key === "b") return "**";
    if (key === "i") return "*";
    return null;
}
